/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.NOTIFICATIONS_SERVICE_URL) {
      throw new Error('NOTIFICATIONS_SERVICE_URL must be set in environment');
    }

    return process.env.NOTIFICATIONS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class SubscriptionsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-notifications-dev.sekoia.one", baseUrl);
    }

    addRemoveSubscribers(subscriptionType: SubscriptionType, id: string | null, request: AddUpdateAndRemoveSubscribersRequest): Promise<void> {
        let url_ = this.baseUrl + "/api/subscriptions/{subscriptionType}/{id}";
        if (subscriptionType === undefined || subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' must be defined.");
        url_ = url_.replace("{subscriptionType}", encodeURIComponent("" + subscriptionType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddRemoveSubscribers(_response);
        });
    }

    protected processAddRemoveSubscribers(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getSubscription(subscriptionType: SubscriptionType, id: string | null): Promise<SubscriptionResponse> {
        let url_ = this.baseUrl + "/api/subscriptions/{subscriptionType}/{id}";
        if (subscriptionType === undefined || subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' must be defined.");
        url_ = url_.replace("{subscriptionType}", encodeURIComponent("" + subscriptionType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubscription(_response);
        });
    }

    protected processGetSubscription(response: Response): Promise<SubscriptionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SubscriptionResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionResponse>(<any>null);
    }

    getSubscriptions(subscriptionType: SubscriptionType, request: GetSubscriptionsRequest): Promise<SubscriptionResponse[]> {
        let url_ = this.baseUrl + "/api/subscriptions/{subscriptionType}/query";
        if (subscriptionType === undefined || subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' must be defined.");
        url_ = url_.replace("{subscriptionType}", encodeURIComponent("" + subscriptionType));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSubscriptions(_response);
        });
    }

    protected processGetSubscriptions(response: Response): Promise<SubscriptionResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SubscriptionResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SubscriptionResponse[]>(<any>null);
    }
}

export class NotificationsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-notifications-dev.sekoia.one", baseUrl);
    }

    getNotifications(): Promise<NotificationResponse[]> {
        let url_ = this.baseUrl + "/api/notifications";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotifications(_response);
        });
    }

    protected processGetNotifications(response: Response): Promise<NotificationResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(NotificationResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationResponse[]>(<any>null);
    }

    updateNotifications(requests: NotificationRequest[]): Promise<void> {
        let url_ = this.baseUrl + "/api/notifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requests);

        let options_ = <RequestInit>{
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNotifications(_response);
        });
    }

    protected processUpdateNotifications(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getNotificationUnreadCount(): Promise<NotificationCountResponse> {
        let url_ = this.baseUrl + "/api/notifications/unread";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetNotificationUnreadCount(_response);
        });
    }

    protected processGetNotificationUnreadCount(response: Response): Promise<NotificationCountResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NotificationCountResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationCountResponse>(<any>null);
    }
}

export enum SubscriptionType {
    Unknown = "Unknown",
    FormSubscription = "FormSubscription",
    TaskNotCompletedOnTimeSubscription = "TaskNotCompletedOnTimeSubscription",
    MedicinePrescriptionInventoryItemSubscription = "MedicinePrescriptionInventoryItemSubscription",
    MedicinePnPescriptionSubscription = "MedicinePnPescriptionSubscription",
}

export class AddUpdateAndRemoveSubscribersRequest implements IAddUpdateAndRemoveSubscribersRequest {
    subscribersToAddOrUpdate!: SubscriptionRequest[];
    subscribersToRemove!: string[];

    constructor(data?: IAddUpdateAndRemoveSubscribersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subscribersToAddOrUpdate = [];
            this.subscribersToRemove = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["subscribersToAddOrUpdate"])) {
                this.subscribersToAddOrUpdate = [] as any;
                for (let item of _data["subscribersToAddOrUpdate"])
                    this.subscribersToAddOrUpdate!.push(SubscriptionRequest.fromJS(item));
            }
            if (Array.isArray(_data["subscribersToRemove"])) {
                this.subscribersToRemove = [] as any;
                for (let item of _data["subscribersToRemove"])
                    this.subscribersToRemove!.push(item);
            }
        }
    }

    static fromJS(data: any): AddUpdateAndRemoveSubscribersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUpdateAndRemoveSubscribersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.subscribersToAddOrUpdate)) {
            data["subscribersToAddOrUpdate"] = [];
            for (let item of this.subscribersToAddOrUpdate)
                data["subscribersToAddOrUpdate"].push(item.toJSON());
        }
        if (Array.isArray(this.subscribersToRemove)) {
            data["subscribersToRemove"] = [];
            for (let item of this.subscribersToRemove)
                data["subscribersToRemove"].push(item);
        }
        return data; 
    }
}

export interface IAddUpdateAndRemoveSubscribersRequest {
    subscribersToAddOrUpdate: SubscriptionRequest[];
    subscribersToRemove: string[];
}

export class SubscriptionRequest implements ISubscriptionRequest {
    employeeId!: string;
    notifyByEmail!: boolean;
    filters?: string[] | undefined;

    constructor(data?: ISubscriptionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.notifyByEmail = _data["notifyByEmail"];
            if (Array.isArray(_data["filters"])) {
                this.filters = [] as any;
                for (let item of _data["filters"])
                    this.filters!.push(item);
            }
        }
    }

    static fromJS(data: any): SubscriptionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["notifyByEmail"] = this.notifyByEmail;
        if (Array.isArray(this.filters)) {
            data["filters"] = [];
            for (let item of this.filters)
                data["filters"].push(item);
        }
        return data; 
    }
}

export interface ISubscriptionRequest {
    employeeId: string;
    notifyByEmail: boolean;
    filters?: string[] | undefined;
}

export class SubscriptionResponse implements ISubscriptionResponse {
    id!: string;
    type!: SubscriptionType;
    customerId!: string;
    subscribers!: SubscriberResponse[];

    constructor(data?: ISubscriptionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.subscribers = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["subscribers"])) {
                this.subscribers = [] as any;
                for (let item of _data["subscribers"])
                    this.subscribers!.push(SubscriberResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriptionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.subscribers)) {
            data["subscribers"] = [];
            for (let item of this.subscribers)
                data["subscribers"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISubscriptionResponse {
    id: string;
    type: SubscriptionType;
    customerId: string;
    subscribers: SubscriberResponse[];
}

export class SubscriberResponse implements ISubscriberResponse {
    id!: string;
    notifyByEmail!: boolean;
    subscriptionFilters?: SubscriptionFilterResponse[] | undefined;

    constructor(data?: ISubscriberResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.notifyByEmail = _data["notifyByEmail"];
            if (Array.isArray(_data["subscriptionFilters"])) {
                this.subscriptionFilters = [] as any;
                for (let item of _data["subscriptionFilters"])
                    this.subscriptionFilters!.push(SubscriptionFilterResponse.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SubscriberResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriberResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["notifyByEmail"] = this.notifyByEmail;
        if (Array.isArray(this.subscriptionFilters)) {
            data["subscriptionFilters"] = [];
            for (let item of this.subscriptionFilters)
                data["subscriptionFilters"].push(item.toJSON());
        }
        return data; 
    }
}

export interface ISubscriberResponse {
    id: string;
    notifyByEmail: boolean;
    subscriptionFilters?: SubscriptionFilterResponse[] | undefined;
}

export class SubscriptionFilterResponse implements ISubscriptionFilterResponse {
    operator!: Operator;
    condition!: Condition;
    value!: string;

    constructor(data?: ISubscriptionFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.operator = _data["operator"];
            this.condition = _data["condition"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): SubscriptionFilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionFilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["operator"] = this.operator;
        data["condition"] = this.condition;
        data["value"] = this.value;
        return data; 
    }
}

export interface ISubscriptionFilterResponse {
    operator: Operator;
    condition: Condition;
    value: string;
}

export enum Operator {
    Or = "Or",
}

export enum Condition {
    LessThanOrEqualTo = "LessThanOrEqualTo",
}

export class GetSubscriptionsRequest implements IGetSubscriptionsRequest {
    ids!: string[];

    constructor(data?: IGetSubscriptionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.ids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
        }
    }

    static fromJS(data: any): GetSubscriptionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetSubscriptionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data; 
    }
}

export interface IGetSubscriptionsRequest {
    ids: string[];
}

export class NotificationResponse implements INotificationResponse {
    id!: string;
    customerId!: string;
    createdAt!: moment.Moment;
    isRead!: boolean;

    protected _discriminator: string;

    constructor(data?: INotificationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "NotificationResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.customerId = _data["customerId"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): NotificationResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "FormRegistrationNotificationResponse") {
            let result = new FormRegistrationNotificationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TaskNotCompletedOnTimeNotificationResponse") {
            let result = new TaskNotCompletedOnTimeNotificationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TaskMovedNotificationResponse") {
            let result = new TaskMovedNotificationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TaskCancelledNotificationResponse") {
            let result = new TaskCancelledNotificationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementRegistrationNotificationResponse") {
            let result = new HealthMeasurementRegistrationNotificationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AdHocTaskCreatedNotificationResponse") {
            let result = new AdHocTaskCreatedNotificationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PrescriptionInventoryItemRemainingQuantityMatchedFilterNotificationResponse") {
            let result = new PrescriptionInventoryItemRemainingQuantityMatchedFilterNotificationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PnEffectRegistrationNotCompletedOnTimeNotificationResponse") {
            let result = new PnEffectRegistrationNotCompletedOnTimeNotificationResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AnalysisEmployeeResponsibleAddedResponse") {
            let result = new AnalysisEmployeeResponsibleAddedResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ActionEmployeeAddedAsCoResponsibleResponse") {
            let result = new ActionEmployeeAddedAsCoResponsibleResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ActionEmployeeAddedAsFollowUpCoResponsibleResponse") {
            let result = new ActionEmployeeAddedAsFollowUpCoResponsibleResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ActionEmployeeSetAsFollowUpResponsibleResponse") {
            let result = new ActionEmployeeSetAsFollowUpResponsibleResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ActionEmployeeSetAsResponsibleResponse") {
            let result = new ActionEmployeeSetAsResponsibleResponse();
            result.init(data);
            return result;
        }
        let result = new NotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["id"] = this.id;
        data["customerId"] = this.customerId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isRead"] = this.isRead;
        return data; 
    }
}

export interface INotificationResponse {
    id: string;
    customerId: string;
    createdAt: moment.Moment;
    isRead: boolean;
}

export class FormRegistrationNotificationResponse extends NotificationResponse implements IFormRegistrationNotificationResponse {
    formId!: string;
    formTitle!: string;
    residentId!: string;
    registrantId!: string;
    registrationId!: string;

    constructor(data?: IFormRegistrationNotificationResponse) {
        super(data);
        this._discriminator = "FormRegistrationNotificationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formId = _data["formId"];
            this.formTitle = _data["formTitle"];
            this.residentId = _data["residentId"];
            this.registrantId = _data["registrantId"];
            this.registrationId = _data["registrationId"];
        }
    }

    static fromJS(data: any): FormRegistrationNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormRegistrationNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId;
        data["formTitle"] = this.formTitle;
        data["residentId"] = this.residentId;
        data["registrantId"] = this.registrantId;
        data["registrationId"] = this.registrationId;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormRegistrationNotificationResponse extends INotificationResponse {
    formId: string;
    formTitle: string;
    residentId: string;
    registrantId: string;
    registrationId: string;
}

export class TaskNotCompletedOnTimeNotificationResponse extends NotificationResponse implements ITaskNotCompletedOnTimeNotificationResponse {
    intervalStartTime!: moment.Moment;
    intervalEndTime!: moment.Moment;
    residentId!: string;
    standardTaskId!: string;
    taskTitle!: string;
    taskInstanceId!: string;

    constructor(data?: ITaskNotCompletedOnTimeNotificationResponse) {
        super(data);
        this._discriminator = "TaskNotCompletedOnTimeNotificationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>undefined;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>undefined;
            this.residentId = _data["residentId"];
            this.standardTaskId = _data["standardTaskId"];
            this.taskTitle = _data["taskTitle"];
            this.taskInstanceId = _data["taskInstanceId"];
        }
    }

    static fromJS(data: any): TaskNotCompletedOnTimeNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskNotCompletedOnTimeNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>undefined;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>undefined;
        data["residentId"] = this.residentId;
        data["standardTaskId"] = this.standardTaskId;
        data["taskTitle"] = this.taskTitle;
        data["taskInstanceId"] = this.taskInstanceId;
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskNotCompletedOnTimeNotificationResponse extends INotificationResponse {
    intervalStartTime: moment.Moment;
    intervalEndTime: moment.Moment;
    residentId: string;
    standardTaskId: string;
    taskTitle: string;
    taskInstanceId: string;
}

export class TaskMovedNotificationResponse extends NotificationResponse implements ITaskMovedNotificationResponse {
    intervalStartTime!: moment.Moment;
    intervalEndTime!: moment.Moment;
    residentId!: string;
    standardTaskId!: string;
    taskTitle!: string;
    taskInstanceId!: string;
    taskMovedByEmployeeId!: string;

    constructor(data?: ITaskMovedNotificationResponse) {
        super(data);
        this._discriminator = "TaskMovedNotificationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>undefined;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>undefined;
            this.residentId = _data["residentId"];
            this.standardTaskId = _data["standardTaskId"];
            this.taskTitle = _data["taskTitle"];
            this.taskInstanceId = _data["taskInstanceId"];
            this.taskMovedByEmployeeId = _data["taskMovedByEmployeeId"];
        }
    }

    static fromJS(data: any): TaskMovedNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskMovedNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>undefined;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>undefined;
        data["residentId"] = this.residentId;
        data["standardTaskId"] = this.standardTaskId;
        data["taskTitle"] = this.taskTitle;
        data["taskInstanceId"] = this.taskInstanceId;
        data["taskMovedByEmployeeId"] = this.taskMovedByEmployeeId;
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskMovedNotificationResponse extends INotificationResponse {
    intervalStartTime: moment.Moment;
    intervalEndTime: moment.Moment;
    residentId: string;
    standardTaskId: string;
    taskTitle: string;
    taskInstanceId: string;
    taskMovedByEmployeeId: string;
}

export class TaskCancelledNotificationResponse extends NotificationResponse implements ITaskCancelledNotificationResponse {
    intervalStartTime!: moment.Moment;
    intervalEndTime!: moment.Moment;
    residentId!: string;
    standardTaskId!: string;
    taskTitle!: string;
    taskInstanceId!: string;
    taskCancelledByEmployeeId!: string;

    constructor(data?: ITaskCancelledNotificationResponse) {
        super(data);
        this._discriminator = "TaskCancelledNotificationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>undefined;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>undefined;
            this.residentId = _data["residentId"];
            this.standardTaskId = _data["standardTaskId"];
            this.taskTitle = _data["taskTitle"];
            this.taskInstanceId = _data["taskInstanceId"];
            this.taskCancelledByEmployeeId = _data["taskCancelledByEmployeeId"];
        }
    }

    static fromJS(data: any): TaskCancelledNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskCancelledNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>undefined;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>undefined;
        data["residentId"] = this.residentId;
        data["standardTaskId"] = this.standardTaskId;
        data["taskTitle"] = this.taskTitle;
        data["taskInstanceId"] = this.taskInstanceId;
        data["taskCancelledByEmployeeId"] = this.taskCancelledByEmployeeId;
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskCancelledNotificationResponse extends INotificationResponse {
    intervalStartTime: moment.Moment;
    intervalEndTime: moment.Moment;
    residentId: string;
    standardTaskId: string;
    taskTitle: string;
    taskInstanceId: string;
    taskCancelledByEmployeeId: string;
}

export class HealthMeasurementRegistrationNotificationResponse extends NotificationResponse implements IHealthMeasurementRegistrationNotificationResponse {
    registrationId!: string;
    registrantId!: string;
    residentId!: string;
    measurementTypeDiscriminator!: string;

    constructor(data?: IHealthMeasurementRegistrationNotificationResponse) {
        super(data);
        this._discriminator = "HealthMeasurementRegistrationNotificationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.registrationId = _data["registrationId"];
            this.registrantId = _data["registrantId"];
            this.residentId = _data["residentId"];
            this.measurementTypeDiscriminator = _data["measurementTypeDiscriminator"];
        }
    }

    static fromJS(data: any): HealthMeasurementRegistrationNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementRegistrationNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["registrationId"] = this.registrationId;
        data["registrantId"] = this.registrantId;
        data["residentId"] = this.residentId;
        data["measurementTypeDiscriminator"] = this.measurementTypeDiscriminator;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementRegistrationNotificationResponse extends INotificationResponse {
    registrationId: string;
    registrantId: string;
    residentId: string;
    measurementTypeDiscriminator: string;
}

export class AdHocTaskCreatedNotificationResponse extends NotificationResponse implements IAdHocTaskCreatedNotificationResponse {
    residentId!: string;
    taskCreatedByEmployeeId!: string;
    intervalStartTime!: moment.Moment;
    intervalEndTime!: moment.Moment;
    taskTitle!: string;
    taskInstanceId!: string;
    standardTaskId!: string;

    constructor(data?: IAdHocTaskCreatedNotificationResponse) {
        super(data);
        this._discriminator = "AdHocTaskCreatedNotificationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.residentId = _data["residentId"];
            this.taskCreatedByEmployeeId = _data["taskCreatedByEmployeeId"];
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>undefined;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>undefined;
            this.taskTitle = _data["taskTitle"];
            this.taskInstanceId = _data["taskInstanceId"];
            this.standardTaskId = _data["standardTaskId"];
        }
    }

    static fromJS(data: any): AdHocTaskCreatedNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AdHocTaskCreatedNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        data["taskCreatedByEmployeeId"] = this.taskCreatedByEmployeeId;
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>undefined;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>undefined;
        data["taskTitle"] = this.taskTitle;
        data["taskInstanceId"] = this.taskInstanceId;
        data["standardTaskId"] = this.standardTaskId;
        super.toJSON(data);
        return data; 
    }
}

export interface IAdHocTaskCreatedNotificationResponse extends INotificationResponse {
    residentId: string;
    taskCreatedByEmployeeId: string;
    intervalStartTime: moment.Moment;
    intervalEndTime: moment.Moment;
    taskTitle: string;
    taskInstanceId: string;
    standardTaskId: string;
}

export class PrescriptionInventoryItemRemainingQuantityMatchedFilterNotificationResponse extends NotificationResponse implements IPrescriptionInventoryItemRemainingQuantityMatchedFilterNotificationResponse {
    correlationId!: string;
    prescriptionInventoryItemId!: string;
    residentId!: string;
    drugName!: string;
    before!: number;
    after!: number;
    filterValue!: string;

    constructor(data?: IPrescriptionInventoryItemRemainingQuantityMatchedFilterNotificationResponse) {
        super(data);
        this._discriminator = "PrescriptionInventoryItemRemainingQuantityMatchedFilterNotificationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.correlationId = _data["correlationId"];
            this.prescriptionInventoryItemId = _data["prescriptionInventoryItemId"];
            this.residentId = _data["residentId"];
            this.drugName = _data["drugName"];
            this.before = _data["before"];
            this.after = _data["after"];
            this.filterValue = _data["filterValue"];
        }
    }

    static fromJS(data: any): PrescriptionInventoryItemRemainingQuantityMatchedFilterNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrescriptionInventoryItemRemainingQuantityMatchedFilterNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["correlationId"] = this.correlationId;
        data["prescriptionInventoryItemId"] = this.prescriptionInventoryItemId;
        data["residentId"] = this.residentId;
        data["drugName"] = this.drugName;
        data["before"] = this.before;
        data["after"] = this.after;
        data["filterValue"] = this.filterValue;
        super.toJSON(data);
        return data; 
    }
}

export interface IPrescriptionInventoryItemRemainingQuantityMatchedFilterNotificationResponse extends INotificationResponse {
    correlationId: string;
    prescriptionInventoryItemId: string;
    residentId: string;
    drugName: string;
    before: number;
    after: number;
    filterValue: string;
}

export class PnEffectRegistrationNotCompletedOnTimeNotificationResponse extends NotificationResponse implements IPnEffectRegistrationNotCompletedOnTimeNotificationResponse {
    residentId!: string;
    drugName!: string;
    form!: string;
    strength!: string;
    startTime!: moment.Moment;
    endTime!: moment.Moment;

    constructor(data?: IPnEffectRegistrationNotCompletedOnTimeNotificationResponse) {
        super(data);
        this._discriminator = "PnEffectRegistrationNotCompletedOnTimeNotificationResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.residentId = _data["residentId"];
            this.drugName = _data["drugName"];
            this.form = _data["form"];
            this.strength = _data["strength"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PnEffectRegistrationNotCompletedOnTimeNotificationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnEffectRegistrationNotCompletedOnTimeNotificationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        data["drugName"] = this.drugName;
        data["form"] = this.form;
        data["strength"] = this.strength;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IPnEffectRegistrationNotCompletedOnTimeNotificationResponse extends INotificationResponse {
    residentId: string;
    drugName: string;
    form: string;
    strength: string;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class AnalysisEmployeeResponsibleAddedResponse extends NotificationResponse implements IAnalysisEmployeeResponsibleAddedResponse {
    incidentId!: number;
    incidentTitle!: string;
    addedByEmployeeId!: string;

    constructor(data?: IAnalysisEmployeeResponsibleAddedResponse) {
        super(data);
        this._discriminator = "AnalysisEmployeeResponsibleAddedResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incidentId = _data["incidentId"];
            this.incidentTitle = _data["incidentTitle"];
            this.addedByEmployeeId = _data["addedByEmployeeId"];
        }
    }

    static fromJS(data: any): AnalysisEmployeeResponsibleAddedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnalysisEmployeeResponsibleAddedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentId"] = this.incidentId;
        data["incidentTitle"] = this.incidentTitle;
        data["addedByEmployeeId"] = this.addedByEmployeeId;
        super.toJSON(data);
        return data; 
    }
}

export interface IAnalysisEmployeeResponsibleAddedResponse extends INotificationResponse {
    incidentId: number;
    incidentTitle: string;
    addedByEmployeeId: string;
}

export class ActionEmployeeAddedAsCoResponsibleResponse extends NotificationResponse implements IActionEmployeeAddedAsCoResponsibleResponse {
    incidentId!: number;
    incidentTitle!: string;
    addedByEmployeeId!: string;

    constructor(data?: IActionEmployeeAddedAsCoResponsibleResponse) {
        super(data);
        this._discriminator = "ActionEmployeeAddedAsCoResponsibleResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incidentId = _data["incidentId"];
            this.incidentTitle = _data["incidentTitle"];
            this.addedByEmployeeId = _data["addedByEmployeeId"];
        }
    }

    static fromJS(data: any): ActionEmployeeAddedAsCoResponsibleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionEmployeeAddedAsCoResponsibleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentId"] = this.incidentId;
        data["incidentTitle"] = this.incidentTitle;
        data["addedByEmployeeId"] = this.addedByEmployeeId;
        super.toJSON(data);
        return data; 
    }
}

export interface IActionEmployeeAddedAsCoResponsibleResponse extends INotificationResponse {
    incidentId: number;
    incidentTitle: string;
    addedByEmployeeId: string;
}

export class ActionEmployeeAddedAsFollowUpCoResponsibleResponse extends NotificationResponse implements IActionEmployeeAddedAsFollowUpCoResponsibleResponse {
    incidentId!: number;
    incidentTitle!: string;
    addedByEmployeeId!: string;

    constructor(data?: IActionEmployeeAddedAsFollowUpCoResponsibleResponse) {
        super(data);
        this._discriminator = "ActionEmployeeAddedAsFollowUpCoResponsibleResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incidentId = _data["incidentId"];
            this.incidentTitle = _data["incidentTitle"];
            this.addedByEmployeeId = _data["addedByEmployeeId"];
        }
    }

    static fromJS(data: any): ActionEmployeeAddedAsFollowUpCoResponsibleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionEmployeeAddedAsFollowUpCoResponsibleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentId"] = this.incidentId;
        data["incidentTitle"] = this.incidentTitle;
        data["addedByEmployeeId"] = this.addedByEmployeeId;
        super.toJSON(data);
        return data; 
    }
}

export interface IActionEmployeeAddedAsFollowUpCoResponsibleResponse extends INotificationResponse {
    incidentId: number;
    incidentTitle: string;
    addedByEmployeeId: string;
}

export class ActionEmployeeSetAsFollowUpResponsibleResponse extends NotificationResponse implements IActionEmployeeSetAsFollowUpResponsibleResponse {
    incidentId!: number;
    incidentTitle!: string;
    addedByEmployeeId!: string;

    constructor(data?: IActionEmployeeSetAsFollowUpResponsibleResponse) {
        super(data);
        this._discriminator = "ActionEmployeeSetAsFollowUpResponsibleResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incidentId = _data["incidentId"];
            this.incidentTitle = _data["incidentTitle"];
            this.addedByEmployeeId = _data["addedByEmployeeId"];
        }
    }

    static fromJS(data: any): ActionEmployeeSetAsFollowUpResponsibleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionEmployeeSetAsFollowUpResponsibleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentId"] = this.incidentId;
        data["incidentTitle"] = this.incidentTitle;
        data["addedByEmployeeId"] = this.addedByEmployeeId;
        super.toJSON(data);
        return data; 
    }
}

export interface IActionEmployeeSetAsFollowUpResponsibleResponse extends INotificationResponse {
    incidentId: number;
    incidentTitle: string;
    addedByEmployeeId: string;
}

export class ActionEmployeeSetAsResponsibleResponse extends NotificationResponse implements IActionEmployeeSetAsResponsibleResponse {
    incidentId!: number;
    incidentTitle!: string;
    addedByEmployeeId!: string;

    constructor(data?: IActionEmployeeSetAsResponsibleResponse) {
        super(data);
        this._discriminator = "ActionEmployeeSetAsResponsibleResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incidentId = _data["incidentId"];
            this.incidentTitle = _data["incidentTitle"];
            this.addedByEmployeeId = _data["addedByEmployeeId"];
        }
    }

    static fromJS(data: any): ActionEmployeeSetAsResponsibleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ActionEmployeeSetAsResponsibleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incidentId"] = this.incidentId;
        data["incidentTitle"] = this.incidentTitle;
        data["addedByEmployeeId"] = this.addedByEmployeeId;
        super.toJSON(data);
        return data; 
    }
}

export interface IActionEmployeeSetAsResponsibleResponse extends INotificationResponse {
    incidentId: number;
    incidentTitle: string;
    addedByEmployeeId: string;
}

export class NotificationCountResponse implements INotificationCountResponse {
    count!: number;

    constructor(data?: INotificationCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): NotificationCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data; 
    }
}

export interface INotificationCountResponse {
    count: number;
}

export class NotificationRequest implements INotificationRequest {
    id!: string;
    isRead!: boolean;

    constructor(data?: INotificationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isRead = _data["isRead"];
        }
    }

    static fromJS(data: any): NotificationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isRead"] = this.isRead;
        return data; 
    }
}

export interface INotificationRequest {
    id: string;
    isRead: boolean;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}